import { render, staticRenderFns } from "./AnimateBox.vue?vue&type=template&id=c4cd16a4&"
import script from "./AnimateBox.vue?vue&type=script&lang=js&"
export * from "./AnimateBox.vue?vue&type=script&lang=js&"
import style0 from "./AnimateBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports